<div class="bg-white border border-neutral-200 rounded-xl w-fit p-4">
  <p class="text-sm">{{ title }}</p>

  @if (tabs) {
    <div class="cursor-pointer flex gap-x-5 mt-4">
      @for (tab of tabs.toArray(); track tab; let i = $index) {
        <div
          (click)="selectTab(i)"
          [class.active]="i === activeTabIndex"
          class="py-1 border-b-2 border-transparent tab-title text-sm"
        >
          {{ tab.tabTitle }}
        </div>
      }
    </div>
    <div class="mt-4">
      @if (tabs.toArray()[activeTabIndex]) {
        <ng-container *ngTemplateOutlet="tabs.toArray()[activeTabIndex].template"></ng-container>
      }
    </div>
  }
</div>
